<script>
    import BaseBrick from "./BaseBrick.svelte";
    export let x;
    export let y;
    export let tx;
    export let ty;
    export let l1x;
    export let l1y;
    export let l2x;
    export let l2y;
    export let step;
    export let scale;
    export let cw;
    export let ch;
    export let vl;
</script>

<BaseBrick
        className="block-brick"
        bind:x={x}
        bind:y={y}
        bind:tx={tx}
        bind:ty={ty}
        bind:l1x={l1x}
        bind:l1y={l1y}
        bind:l2x={l2x}
        bind:l2y={l2y}
        bind:step={step}
        bind:scale={scale}
        bind:cw={cw}
        bind:ch={ch}
        bind:vl={vl}
/>
